type ErrorType =
  | 'exchange'
  | 'bankAccount'
  | 'banner'
  | 'faq'
  | 'youtube'
  | 'user'
  | 'auth'
  | 'community'
  | 'notification'
  | 'nice'
  | 'adminAuth'
  | 'platformCategory'
  | 'snsAccount'
  | 'adminUser'
  | 'viewing'
  | 'point'
  | 'badge'
  | 'imageServer'
  | 'statistics'
  | 'autoSave'
  | 'albaone'
  | 'adminManagementHistory';

type UnauthorizedErrorType = 'unauthorized';
export type ErrorCodeString = `${ErrorType}-${number}` | UnauthorizedErrorType;

export interface ErrorResponse<T = unknown> {
  code: keyof typeof errorMessage | string;
  detail?: T;
}

export interface V2ErrorResponse {
  code: string;
}

// v2 `PATCH /v2/sns-accounts/viewup/{uuid}/active` 가 v1 의 snsAccount-031 / snsAccount-077 대신 내려주는 코드.
type V2SnsAccountActiveErrorCode = 'snsAccountNotApproved' | 'snsAccountIsError';

type ErrorCodeType = {
  [K in ErrorCodeString | V2SnsAccountActiveErrorCode]: string;
};

const SNS_ACCOUNT_NOT_APPROVED_MESSAGE = '해당 계정은 승인되지 않은 계정입니다.';
const SNS_ACCOUNT_ACTIVATE_ERROR_MESSAGE =
  '활성화하려는 계정에서 오류가 발생했습니다. 계정 상태를 다시 한번 확인해 주세요.';

export const errorMessage: ErrorCodeType = {
  snsAccountNotApproved: SNS_ACCOUNT_NOT_APPROVED_MESSAGE,
  snsAccountIsError: SNS_ACCOUNT_ACTIVATE_ERROR_MESSAGE,
  'adminAuth-001': '어드민 권한을 찾을 수 없습니다.',
  'adminAuth-002': '이미 존재하는 아이디입니다.',
  'adminAuth-003': '회원가입에 실패했습니다.',
  'adminAuth-004': '아이디 또는 비밀번호가 일치하지 않습니다.',
  'adminAuth-005': 'db에 connection이 존재하지 않습니다.',
  'adminAuth-006': '로그인에 실패했습니다.',
  'adminAuth-007': '아이디와 비밀번호를 필수로 입력해 주세요.',
  'adminAuth-008': '유효하지 않은 token입니다. 다시 로그인해 주세요.',
  'adminAuth-009': '어드민 권한이 없습니다.',
  'adminAuth-010': '마스터 관리자 권한이 없습니다.',
  'adminAuth-011': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: adminAuth-011',
  'adminAuth-012': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: adminAuth-012',
  'adminAuth-013': 'token에 있는 Uuid로 유저를 찾을 수 없습니다. 관리자에게 문의해 주세요.',
  'adminAuth-014': '기존 비밀번호가 일치하지 않습니다.',
  'adminAuth-015': '비밀번호 변경에 실패했습니다.',
  'adminAuth-016': '유효하지 않은 token입니다. 다시 로그인해 주세요',
  'adminManagementHistory-001': '어드민 관리이력 생성에 실패했습니다. 관리자에게 문의해 주세요.',
  'adminManagementHistory-002': '어드민 관리이력 생성에 실패했습니다. 관리자에게 문의해 주세요.',
  'adminManagementHistory-003':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminManagementHistory-003',
  'adminManagementHistory-004':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminManagementHistory-004',
  'adminManagementHistory-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminManagementHistory-005',
  'adminManagementHistory-006':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminManagementHistory-006',
  'adminManagementHistory-007':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminManagementHistory-007',
  'adminManagementHistory-008': '어드민 관리이력 조회에 실패했습니다. 관리자에게 문의해 주세요.',
  'adminUser-001': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminUser-001',
  'adminUser-002': '아이디는 영문, 숫자만 사용할 수 있습니다.',
  'adminUser-003': '비밀번호 형식이 맞지 않습니다.',
  'adminUser-004': 'name이 string이 아닙니다.',
  'adminUser-005': '어드민 유저 전체 조회에 실패했습니다.',
  'adminUser-006': '유저 개별 조회에 실패했습니다.',
  'adminUser-007': '해당 유저를 찾을 수 없습니다.',
  'adminUser-008': '해당 권한이 없습니다.',
  'adminUser-009': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminUser-009',
  'adminUser-010': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: adminUser-010',
  'adminUser-011': '어드민 본인 정보 조회에 실패했습니다.',
  'adminUser-012': '어드민 유저 삭제에 실패했습니다.',
  'adminUser-013': '전체 관리자 회원명 조회에 실패했습니다.',
  'adminUser-014': '회원가입 경로 조회에 실패했습니다.',
  'adminUser-015': 'page: 1 이상의 정수를 입력해 주세요.',
  'adminUser-016': 'limit: 1 이상의 정수를 입력해 주세요.',
  'adminUser-017': 'sort 정렬에 실패했습니다.',
  'adminUser-018': 'keyword 값이 string이어야 합니다.',
  'albaone-001': '성별을 다시 확인해 주세요.',
  'albaone-002': '나이는 숫자 타입이어야 합니다.',
  'albaone-003': '성별 또는 나이를 다시 확인해 주세요.',
  'albaone-004': '알바원 피드 조회에 실패했습니다.',
  'albaone-005': '알바원 피드 조회에 실패했습니다.\n(알바원 서버 에러)',
  'albaone-006': '알바원 피드 조회에 실패했습니다.\n(알바원 서버 기타 에러)',
  'albaone-007': 'uuid를 다시 확인해 주세요.',
  'albaone-008': 'uuid가 유효하지 않습니다.',
  'albaone-009': '피드 게시물 조회에 실패했습니다.',
  'albaone-010': '피드 게시물 조회에 실패했습니다.\n(알바원 서버 에러)',
  'albaone-011': '피드 게시물 조회에 실패했습니다.\n(알바원 서버 기타 에러)',
  'albaone-012': '해당 피드의 게시글을 찾을 수 없습니다.',
  'albaone-013': '잘못된 요청입니다.',
  'albaone-014': '이미 존재하는 snsId입니다.',
  'albaone-015': '연결하는데 오류가 발생했습니다.\n(알바원 서버 에러)',
  'albaone-016': '연결하는데 오류가 발생했습니다.\n(알바원 서버 기타 에러)',
  'albaone-017': '이미 연결된 피드입니다.',
  'albaone-018': '알바원 연결에 실패했습니다.',
  'albaone-019': 'snsId에 string타입만 입력하실 수 있습니다.',
  'albaone-020': 'snsAccountAlbaoneFeedUuid가 일치하지 않습니다.',
  'albaone-021': 'albaoneFeedUuid가 일치하지 않습니다.',
  'albaone-022': '알바원 피드조회 요청 실패\nalbaone-022',
  'albaone-023': '알바원 피드조회 요청 기타 오류\nalbaone-023',
  'albaone-024': '피드업로드 잘못된 요청\nalbaone-024',
  'albaone-025': '계정 꾸미기 실패\nalbaone-025',
  'albaone-026': '계정 꾸미기 실패(알바원 서버 기타 에러)\nalbaone-026',
  'albaone-027': '인증필요\nalbaone-027',
  'albaone-028': '권한 없음\nalbaone-028',
  'albaone-029': '잘못된 요청\nalbaone-029',
  'albaone-030': '피드 업로드 실패\nalbaone-030',
  'albaone-031': '피드 업로드 기타 에러\nalbaone-031',
  'albaone-032': '피드 업로드 인증필요\nalbaone-032',
  'albaone-033': '피드 업로드 권한없음\nalbaone-033',
  'albaone-034': '잘못된 요청입니다\nalbaone-034',
  'albaone-035': '중복된 sns_id\nalbaone-035',
  'albaone-036': '알바원 피드 매치요청 실패\nalbaone-036',
  'albaone-037': '알바원 피드 매치요청 기타 오류\nalbaone-037',
  'albaone-038': '알바원 피드 에러 해결 실패\nalbaone-038',
  'albaone-039': 'new_sns_id => string\nalbaone-039',
  'albaone-040': '잘못된 요청\nalbaone-040',
  'albaone-041': '인스타 게시글 업로드 challange_required 에러',
  'albaone-042': '인스타 게시글 업로드 sentry_block 에러',
  'albaone-043': '인스타 계정 수정 challange_required 에러',
  'albaone-044': 'snsAccountUuid => uuid 에러',
  'albaone-045': '알바원 서버 에러가 발생했습니다. 다시 시도해 주세요.',
  'albaone-046': 'newSnsName => string 에러',
  'albaone-047': 'newImageUrl => string 에러',
  'auth-001': '이미 존재하는 아이디입니다.',
  'auth-002': '회원가입에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-003': '아이디 중복 확인에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-004': '로그인에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-005': '아이디 또는 비밀번호가 일치하지 않습니다.',
  'auth-006': '아이디와 비밀번호를 입력해주세요.',
  'auth-007': '다시 로그인해주세요.\ncode: auth-007',
  'auth-008': '로그아웃에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-009': '로그인이 필요합니다.',
  'auth-010': '다시 로그인해주세요.',
  'auth-011': '토큰 재발급에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-012': '연결에 실패했습니다. 관리자에게 문의해주세요.',
  'auth-013': '가입 시간이 경과하였습니다.\n다시 회원가입을 진행해 주세요.',
  'auth-014': '유효하지 않은 토큰입니다.\n다시 휴대폰 인증 후 시도해 주세요.',
  'auth-015': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: auth-015',
  'auth-016': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: auth-016',
  'auth-017': '기존 비밀번호와 일치하지 않습니다. 다시 입력해 주세요.',
  'auth-018': '기존 비밀번호와 일치하지 않습니다. 다시 입력해 주세요.',
  'auth-019': '형식과 일치하지 않는 패스워드입니다. 다시 입력해주세요.',
  'auth-020': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: auth-020',
  'auth-021': '휴대폰 인증이 필요합니다.',
  'auth-022': '뷰업 서비스 정책상 만 16세 미만의 청소년은 이용할 수 없습니다.',
  'autoSave-001': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: autoSave-001',
  'autoSave-002': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: autoSave-002',
  'autoSave-003': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: autoSave-003',
  'autoSave-004': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: autoSave-004',
  'autoSave-005': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: autoSave-005',
  'badge-001': '뱃지 조회에 실패했습니다. 페이지를 새로고침해주세요.',
  'badge-002': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: badge-002',
  'badge-003': '신규 뱃지 여부를 수정할 뱃지가 존재하지 않습니다.',
  'badge-004': '신규 뱃지 여부를 수정에 실패했습니다',
  'badge-005': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: badge-005',
  'bankAccount-001': '환급할 계좌를 먼저 설정해주세요.',
  'bankAccount-002': '계좌 등록에 실패했습니다. 관리자에게 문의해주세요.',
  'bankAccount-003': '환급은 만원부터 가능합니다.\n환급 가능 금액이 부족해서 계좌 등록이 불가해요.',
  'bankAccount-004': '계좌 정보가 없습니다.',
  'bankAccount-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: bankAccount-005',
  'bankAccount-006': '은행 정보가 없습니다.',
  'bankAccount-007': '이미 등록된 계좌입니다.',
  'bankAccount-008': '기본계좌가 설정되어 있지 않습니다.',
  'bankAccount-009': '기본 계좌 조회에 실패하였습니다. 관리자에게 문의해주세요.',
  'bankAccount-010': '계좌를 삭제하지 못했습니다. 관리자에게 문의해주세요.',
  'bankAccount-011': '해당 계좌 정보가 없습니다.',
  'bankAccount-012': '계좌를 삭제할 수 없습니다. 관리자에게 문의해주세요.',
  'bankAccount-013': '계좌 조회에 실패하였습니다. 관리자에게 문의해주세요.',
  'bankAccount-014':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: bankAccount-014',
  'bankAccount-015':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: bankAccount-015',
  'bankAccount-016': '기본계좌가 될 계좌의 정보가 잘못되었습니다.',
  'bankAccount-017': '현재 기본계좌의 정보가 잘못되었습니다.',
  'bankAccount-018': '기본계좌 설정에 실패햐였습니다. 관리자에게 문의해주세요.',
  'banner-001': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: banner-001',
  'banner-002': '제목은 20byte 이내의 문자열로 입력해주세요.',
  'banner-003': '소제목은 30byte 이내의 문자열로 입력해주세요.',
  'banner-004': '유효한 링크 URL을 입력해주세요.',
  'banner-005': '유효한 링크타입을 입력해주세요.',
  'banner-006': '유효한 이미지 URL을 입력해주세요.',
  'banner-007': '노출여부는 예/아니요로 입력해주세요.',
  'banner-008': '이전 배너 고유번호는 1 이상의 숫자로 입력해주세요.',
  'banner-009': '배너 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'banner-010': '어드민 배너 생성에 실패했습니다. 관리자에게 문의해주세요.',
  'banner-011': '어드민 배너 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'banner-012': '어드민 배너 수정에 실패했습니다. 관리자에게 문의해주세요.',
  'banner-013': '존재하지 않는 배너입니다.',
  'banner-014': '유효하지 않은 순서입니다.',
  'banner-015': '어드민 배너 삭제에 실패했습니다. 관리자에게 문의해주세요.',
  'community-001': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-001',
  'community-002': '카테고리 이름은 문자열로 입력해주세요.',
  'community-003': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-003',
  'community-004': '제목은 30자 이하로 입력해주세요.',
  'community-005': '내용 크기는 1B 이상 80KB 이하로 입력해주세요.',
  'community-006': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-006',
  'community-007': '순서는 1 이상의 숫자로 입력해주세요.',
  'community-008': '유효한 타입을 입력해주세요.',
  'community-009': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-009',
  'community-010': '내용은 1자 이상의 문자로 입력해주세요.',
  'community-011': '커뮤니티 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-012': '게시글 작성에 실패했습니다. 관리자에게 문의해주세요.',
  'community-013': '존재하지 않는 커뮤니티입니다.',
  'community-014': '게시글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-015': '상단고정 게시글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-016': '추천 게시글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-017': '인기 게시글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-018': '베스트 꿀팁 게시글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-019': '게시글 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-020': '존재하지 않는 게시글입니다.',
  'community-021': '게시글 수정에 실패했습니다. 관리자에게 문의해주세요.',
  'community-022': '게시글 수정 권한이 없습니다.',
  'community-023': '카테고리 아이디는 1 이상의 숫자로 입력해주세요.',
  'community-024': '게시글 삭제에 실패했습니다. 관리자에게 문의해주세요.',
  'community-025': '게시글 삭제 권한이 없습니다.',
  'community-026': '좋아요 등록에 실패했습니다. 관리자에게 문의해주세요.',
  'community-027': '이미 좋아요를 누른 게시글입니다.',
  'community-028': '좋아요 취소에 실패했습니다. 관리자에게 문의해주세요.',
  'community-029': '좋아요를 누르지 않은 게시글입니다.',
  'community-030': '좋아요 취소 권한이 없습니다.',
  'community-031': '최근 좋아요 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-032': '좋아요 상태 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-033': '댓글 작성에 실패했습니다. 관리자에게 문의해주세요.',
  'community-034': '존재하지 않는 댓글입니다.',
  'community-035': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-035',
  'community-036': '댓글 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'community-037': '페이지는 1 이상의 숫자로 입력해주세요.',
  'community-038': '1개 이상의 게시글을 조회할 수 있습니다.',
  'community-039': '정렬 방식은 최신순, 댓글순, 좋아요순 중 하나를 입력해주세요.',
  'community-040': '검색은 제목 혹은 작성자 닉네임으로 할 수 있습니다.',
  'community-041': '검색어는 문자열로 입력해주세요.',
  'community-042': '댓글 수정에 실패했습니다. 관리자에게 문의해주세요.',
  'community-043': '댓글 수정 권한이 없습니다.',
  'community-044': '댓글 삭제에 실패했습니다. 관리자에게 문의해주세요.',
  'community-045': '댓글 삭제 권한이 없습니다.',
  'community-046': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-046',
  'community-047': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-047',
  'community-048': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-048',
  'community-049': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-049',
  'community-050': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: community-050',
  'exchange-001': '예금주 정보가 잘못되었습니다.',
  'exchange-002': '본인 인증에 실패하였습니다.\n카카오 채팅상담 1:1문의로 문의해 주세요.',
  'exchange-003': '환급 금액은 10,000원 이상이여야합니다.',
  'exchange-004': '요청한 환급 금액이 환급 가능 금액을 초과하였습니다.',
  'exchange-005': '환급 신청에 실패했습니다. 관리자에게 문의해주세요.',
  'exchange-006': '페이지는 1 이상의 숫자로 입력해주세요.',
  'exchange-007': '1명 이상의 유저를 조회할 수 있습니다.',
  'exchange-008': '환급 내역을 찾을 수 없습니다.',
  'exchange-009': '환급 신청은 만원부터 가능합니다.',
  'exchange-010': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-010',
  'exchange-011': '취소할 환급 정보가 없습니다.',
  'exchange-012': '환급 취소에 실패했습니다. 관리자에게 문의해주세요.',
  'exchange-013': '해당 건은 환급 취소가 불가능합니다. 관리자에게 문의해주세요.',
  'exchange-014': '이미 환급 취소가 완료되었습니다.',
  'exchange-015': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-015',
  'exchange-016': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-016',
  'exchange-017': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-017',
  'exchange-018': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-018',
  'exchange-019': '환급 조회에 실패했습니다.',
  'exchange-020': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-020',
  'exchange-021': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-021',
  'exchange-022': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-022',
  'exchange-023': '완료된 환급은 상태 변경이 불가능합니다.',
  'exchange-024': '불가 처리된 환급은 상태 변경이 불가능합니다.',
  'exchange-025': '신청 상태로는 상태 변경이 불가능합니다.',
  'exchange-026': '신청 -> 완료로 상태 변경이 불가능합니다.',
  'exchange-027': '환급 불가 사유를 기재해주세요.',
  'exchange-028': '환급 불가 기타 사유를 기재해주세요.',
  'exchange-029': '환급 상태 변경에 실패했습니다.',
  'exchange-030': '환급 취소 사유 조회에 실패했습니다.',
  'exchange-031': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-031',
  'exchange-032': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-032',
  'exchange-033': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-033',
  'exchange-034': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-034',
  'exchange-035': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-035',
  'exchange-036': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-036',
  'exchange-037': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-037',
  'exchange-038': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-038',
  'exchange-039': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: exchange-039',
  'exchange-040': '대기상태 일때만 불가상태로 변경이 가능합니다.',
  'exchange-041': '환급 신청은 1건만 가능합니다.',
  'exchange-045': '최소 환급 신청 금액은 10,000원 입니다.',
  'exchange-046': '최대 환급 신청 금액은 990,000원 입니다.',
  'faq-001': '',
  'faq-002': '제목은 160byte 이내의 문자열로 입력해주세요.',
  'faq-003': '내용은 80000byte 이내의 문자열로 입력해주세요.',
  'faq-004': '정렬순서는 1 이상의 숫자로 입력해주세요.',
  'faq-005': '',
  'faq-006': 'FAQ 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'faq-007': '어드민 FAQ 생성에 실패했습니다. 관리자에게 문의해주세요.',
  'faq-008': '어드민 FAQ 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'faq-009': '어드민 FAQ 수정에 실패했습니다. 관리자에게 문의해주세요.',
  'faq-010': '존재하지 않는 FAQ입니다.',
  'faq-011': '유효하지 않은 순서입니다.',
  'faq-012': '어드민 FAQ 삭제에 실패했습니다. 관리자에게 문의해주세요.',
  'imageServer-001':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-001',
  'imageServer-002':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-002',
  'imageServer-003':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-003',
  'imageServer-004':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-004',
  'imageServer-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-005',
  'imageServer-006':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: imageServer-006',
  'nice-001': '암호화 데이터 생성 실패',
  'nice-002': '복호화 실패',
  'nice-003': 'returnUrl ⇒ string',
  'nice-004': 'encodeData ⇒ string',
  'nice-005': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: nice-005',
  'nice-006': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: nice-006',
  'nice-007': 'id가 일치하지 않습니다.',
  'nice-008': '암호화 시스템 오류',
  'nice-009': '암호화 처리 오류',
  'nice-010': '암호화 데이터 오류',
  'nice-011': '입력 정보 오류',
  'nice-012': 'NICE 암호화 오류',
  'nice-013': '복호화 시스템 오류',
  'nice-014': '복호화 처리 오류',
  'nice-015': '복호화 해시 오류',
  'nice-016': '복호화 데이터 오류',
  'nice-017': '입력 정보 오류',
  'nice-018': 'CP 비밀번호 불일치',
  'nice-019': 'NICE 복호화 오류',
  'nice-020': 'NICE에서 오류가 발생했습니다. 다시 시도해 주세요.',
  'nice-021': '은행 점검으로 정보 확인에 실패했습니다.',
  'nice-022': '이미 회원가입이 되어있는 유저입니다.',
  'nice-023': '회원가입이 되지않은 유저입니다.',
  'nice-024': '해당 아이디와 정보가 일치하지 않습니다.',
  'nice-025': '탈퇴 후 90일간 회원가입이 불가합니다.',
  'notification-001': '제목은 40자 이하로 입력해주세요.',
  'notification-002': '내용은 140자 이하로 입력해주세요.',
  'notification-003':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-003',
  'notification-004':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-004',
  'notification-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-005',
  'notification-006':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-006',
  'notification-007':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-007',
  'notification-008':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-008',
  'notification-009': '유저 조회에 실패했습니다. 유효한 userUuid를 입력해주세요.',
  'notification-010':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-010',
  'notification-011':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-011',
  'notification-012':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-012',
  'notification-013':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-013',
  'notification-014':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-014',
  'notification-015':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-015',
  'notification-016':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-016',
  'notification-017':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-017',
  'notification-018':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-018',
  'notification-019':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-019',
  'notification-020':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-020',
  'notification-021':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-021',
  'notification-022':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-022',
  'notification-023':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-023',
  'notification-024':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-024',
  'notification-025':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-025',
  'notification-026':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-026',
  'notification-027':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-027',
  'notification-028':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-028',
  'notification-029':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-029',
  'notification-030':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-030',
  'notification-031':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-031',
  'notification-032':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-032',
  'notification-033':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-033',
  'notification-034':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-034',
  'notification-035':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-035',
  'notification-036':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-036',
  'notification-037':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-037',
  'notification-038':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-038',
  'notification-039':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: notification-039',
  'platformCategory-001':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: platformCategory-001',
  'platformCategory-002':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: platformCategory-002',
  'point-001': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-001',
  'point-002': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-002',
  'point-003': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-003',
  'point-004': '포인트 추이 조회에 실패하였습니다. 관리자에게 문의해주세요.\ncode: point-004',
  'point-005': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-005',
  'point-006': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-006',
  'point-007': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-007',
  'point-008': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-008',
  'point-009': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-009',
  'point-010': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-010',
  'point-011': '누적 포인트 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'point-012': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-012',
  'point-013': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-013',
  'point-014': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-014',
  'point-015': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-015',
  'point-016': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-016',
  'point-017': '지난주 포인트 랭킹 조회에 실패했습니다.',
  'point-018': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-018',
  'point-019': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: point-019',
  'point-020': '누적 포인트 랭킹 조회에 실패했습니다.',
  'point-021': '지난달 포인트 랭킹 조회에 실패했습니다.',
  'point-022': '타입이 일치하지 않아 조회에 실패했습니다.',
  'snsAccount-001': '플랫폼이 존재하지 않습니다. 관리자에게 문의해 주세요.',
  'snsAccount-002':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-002',
  'snsAccount-003':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-003',
  'snsAccount-004':
    '일시적 오류로 계정 추가에 실패했습니다.\n잠시 후 다시 시도해 주시고 지속적 발생 시\n1:1 문의주세요.',
  'snsAccount-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-005',
  'snsAccount-006':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-006',
  'snsAccount-007':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-007',
  'snsAccount-008':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-008',
  'snsAccount-009':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-009',
  'snsAccount-010':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-010',
  'snsAccount-011':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-011',
  'snsAccount-012':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-012',
  'snsAccount-013': 'sns계정 조회에 실패했습니다. 관리자에게 문의해 주세요.',
  'snsAccount-014':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-014',
  'snsAccount-015': '해당 계정은 존재하지 않는 계정입니다.',
  'snsAccount-016': '비밀번호가 알맞지 않습니다.',
  'snsAccount-017': '앱 승인',
  'snsAccount-018': 'OTP인증',
  'snsAccount-019': 'sms인증',
  'snsAccount-020':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-020',
  'snsAccount-021':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-021',
  'snsAccount-022':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-022',
  'snsAccount-023': '인증번호를 다시 입력해 주세요.',
  'snsAccount-024': '기기 인증을 다시 시도해 주세요.',
  'snsAccount-025':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요. (외부 오류)\ncode: snsAccount-025',
  'snsAccount-026':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-026',
  'snsAccount-027':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-027',
  'snsAccount-028':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-028',
  'snsAccount-029':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-029',
  'snsAccount-030': '계정 수정에 실패하였습니다. 관리자에게 문의해 주세요.',
  'snsAccount-031': SNS_ACCOUNT_NOT_APPROVED_MESSAGE,
  'snsAccount-032': '계정 조회에 실패하였습니다. 관리자에게 문의해 주세요.',
  'snsAccount-033': '해당 계정 삭제에 실패하였습니다.',
  'snsAccount-034': '계정을 삭제할 수 있는 권한이 없습니다.',
  'snsAccount-035': '해당 sns계정은 존재하지 않습니다.',
  'snsAccount-036': '계정 활성화/비활성화에 실패하였습니다.',
  'snsAccount-037': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.',
  'snsAccount-038': '뷰업플러스 계정은 6개 이상 등록하실 수 없습니다.',
  'snsAccount-039':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-039',
  'snsAccount-040':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-040',
  'snsAccount-041':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-041',
  'snsAccount-042':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-042',
  'snsAccount-043':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-043',
  'snsAccount-044':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-044',
  'snsAccount-045':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-045',
  'snsAccount-046':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-046',
  'snsAccount-047':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-047',
  'snsAccount-048':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-048',
  'snsAccount-049':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-049',
  'snsAccount-050':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-050',
  'snsAccount-051':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-051',
  'snsAccount-052':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-052',
  'snsAccount-053':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-053',
  'snsAccount-054':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-054',
  'snsAccount-055':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-055',
  'snsAccount-056':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-056',
  'snsAccount-057':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-057',
  'snsAccount-058':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-058',
  'snsAccount-059':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-059',
  'snsAccount-060':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-060',
  'snsAccount-061':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-061',
  'snsAccount-062':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-062',
  'snsAccount-063':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-063',
  'snsAccount-064':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-064',
  'snsAccount-065':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-065',
  'snsAccount-066': 'sns 계정 등록에 실패하였습니다. 관리자에게 문의해 주세요.',
  'snsAccount-067':
    '페이스북 계정 등록에 실패했습니다.\n지속적인 실패 시 관리자에게 문의해 주세요.',
  'snsAccount-068': 'sns 계정 권한이 없습니다.\n계정을 확인 후 다시 시도해주세요.',
  'snsAccount-069':
    '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: snsAccount-069',
  'snsAccount-070':
    '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: snsAccount-070',
  'snsAccount-071':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요. (외부 오류)\ncode: snsAccount-071',
  'snsAccount-072': 'sns 계정 권한이 없습니다. 다시 시도해주세요.',
  'snsAccount-073': '뷰업과 뷰업플러스는 같은 계정을 등록할 수 없습니다.',
  'snsAccount-074': '다른 뷰업계정에 이미 등록된 SNS계정입니다.',
  'snsAccount-075':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-075',
  'snsAccount-076':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: snsAccount-076',
  'snsAccount-077': SNS_ACCOUNT_ACTIVATE_ERROR_MESSAGE,
  'snsAccount-078': '포인트 금액을 불러오는데 실패했습니다. 다시 한번 시도해 주세요.',
  'snsAccount-079': '계정을 조회하는데 실패했습니다. 계정 상태를 다시 한번 확인해 주세요.',
  'snsAccount-080':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요. (외부 오류)\ncode: snsAccount-080',
  'snsAccount-081':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요. (외부 오류)\ncode: snsAccount-081',
  'snsAccount-082': '계정 전환에 실패했습니다.',
  'snsAccount-083':
    '해당 계정의 채널이 존재하지 않습니다.\n유튜브에서 채널 페이지를 생성 후, 계정 등록을 시도해 주세요.',
  'snsAccount-084': '계정 등록 시 휴대폰번호 또는 이메일이 아닌 아이디로 등록해주세요.',
  'snsAccount-085': '인스타그램 피드 조회에 실패했습니다.',
  'snsAccount-086': '조회 요청한 플랫폼이 인스타그램이 아닙니다.',
  'snsAccount-087': '해당 계정이 뷰업플러스 계정이 아닙니다.',
  'snsAccount-088': '인스타그램 게시글 삭제에 실패했습니다.',
  'snsAccount-089': '요청한 게시글을 찾을 수 없습니다.',
  'snsAccount-090': '서버로부터 정의되지 않는 응답을 받았습니다. 관리자에게 문의해 주세요.',
  'snsAccount-091':
    '인증해지 필요로 계정 추가에 실패했습니다.\n인스타그램 앱에서 인증해지 후\n다시 시도해 주세요.',
  'snsAccount-093': '서버 에러가 발생하였습니다.\n 관리자에게 문의해 주세요.',
  'snsAccount-094': '로그아웃에 실패했습니다. 잠시 후 다시 시도해주세요.',
  'snsAccount-097': '다시 로그인을 시도해 주세요.',
  'snsAccount-098':
    '인증해지 필요로 계정 추가에 실패했습니다.\n인스타그램 앱에서 인증해지 후\n다시 시도해 주세요.',
  'snsAccount-099': '인스타그램에서 비밀번호 변경 후 다시 시도해 주세요.',
  'snsAccount-100': '네트워크 연결이 불안정합니다. 잠시 후 다시 시도해 주세요.',
  'snsAccount-101': '모바일 환경에서 인증이 필요합니다.\n모바일에 접속 후 다시 시도해 주세요.',

  'statistics-001': '시작날짜가 오늘보다 많습니다',
  'statistics-002': '아이디는 5~20자로 영문, 숫자만 사용할 수 있습니다.',
  'statistics-003':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: statistics-003',
  'statistics-004':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: statistics-004',
  'statistics-005':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: statistics-005',
  'statistics-006':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: statistics-006',
  'statistics-007':
    '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: statistics-007',
  unauthorized: '',
  'user-001': '유저 고유번호는 1 이상의 숫자로 입력해주세요.',
  'user-002': '아이디는 5자 이상 20자 이하로 입력해주세요.',
  'user-003': '비밀번호는 8자 이상 20자 이하로 입력해주세요.',
  'user-004': '로딩에 실패했습니다. 관리자에게 문의해주세요.',
  'user-005': '유저를 찾을 수 없습니다.',
  'user-006': '페이지는 1 이상의 숫자로 입력해주세요.',
  'user-007': '1명 이상의 유저를 조회할 수 있습니다.',
  'user-008': '전체, 관심, 차단, 메모 중 하나를 선택해주세요.',
  'user-009':
    '등급은 베이비, 프렌즈, 패밀리, 서포트, 수호신, 서포터+수호신 중 하나를 선택해주세요.',
  'user-010':
    '정렬 방식은 계정 수, 누적 적립 금액, 환급액, 잔액, 가입일, 최종 접속일 중 하나를 입력해주세요.',
  'user-011': '오름차순/내림차순을 선택해주세요.',
  'user-012': '검색은 로그인 id 또는 유저 고유번호로 할 수 있습니다.',
  'user-013': '검색어는 문자열로 입력해주세요.',
  'user-014': '로딩에 실패했습니다. 관리자에게 문의해주세요.',
  'user-015': '조회에 실패했습니다.',
  'user-016': '유저 레벨을 입력해주세요.',
  'user-017': '수호신 여부를 입력해주세요',
  'user-018': '서포터즈 여부를 알려주세요.',
  'user-019': '관심 여부를 알려주세요.',
  'user-020': '차단 여부를 알려주세요.',
  'user-021': '메모를 입력해주세요.',
  'user-022': '포인트를 입력해주세요.',
  'user-023': '포인트는 음수가 될 수 없습니다.',
  'user-024': '유저 레벨과 서포터즈/가디언 여부를 정확히 입력해주세요.',
  'user-025': '로딩에 실패했습니다. 관리자에게 문의해주세요.',
  'user-026': '페이지는 1 이상의 숫자로 입력해주세요.',
  'user-027': '1명 이상의 유저를 조회할 수 있습니다.',
  'user-028': '검색어는 문자열로 입력해주세요.',
  'user-029': '로딩에 실패했습니다. 관리자에게 문의해주세요.\ncode: user-029',
  'user-030': '로딩에 실패했습니다. 관리자에게 문의해주세요.\ncode: user-030',
  'user-031': '존재하지 않는 환급 신청 정보입니다.',
  'user-032': '존재하지 않는 내 정보입니다.',
  'user-033': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-033',
  'user-034': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-034',
  'user-035': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-035',
  'user-036': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-036',
  'user-037': '이미 존재하는 닉네임입니다.',
  'user-038': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-038',
  'user-039': '변경하려는 닉네임이 존재합니다.',
  'user-040': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-040',
  'user-041': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-041',
  'user-042': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-042',
  'user-043': '회원 탈퇴에 실패했습니다. 관리자에게 문의해주세요.',
  'user-044': '회원 탈퇴 취소에 실패했습니다. 관리자에게 문의해주세요.',
  'user-045': '포인트 지급 대상을 다시 확인해주세요.',
  'user-046': '포인트 지급 사유를 다시 확인해주세요.',
  'user-047': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-047',
  'user-048': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-048',
  'user-049': '민원 처리에 실패했습니다. 잠시후 다시 시도해주세요.',
  'user-050': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-050',
  'user-051': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-051',
  'user-052': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: user-052',
  'viewing-005': '캠페인 조회에 실패했습니다.',
  'viewing-006': '서버 에러가 발생했습니다. 관리자에게 문의해 주세요.',
  'viewing-007': '계정을 찾을 수 없습니다.',
  'viewing-008': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-008',
  'viewing-009': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-009',
  'viewing-010': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-010',
  'viewing-011': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-011',
  'viewing-012': '클릭형 캠페인 참여 상태 확인에 실패했습니다.',
  'viewing-013': '클릭형 캠페인 참여 인증에 실패했습니다.',
  'viewing-014': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-014',
  'viewing-015': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-015',
  'viewing-016': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-016',
  'viewing-017': '해당 뷰잉 로그를 찾을 수 없습니다.',
  'viewing-018': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-018',
  'viewing-019': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-019',
  'viewing-020': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-020',
  'viewing-021': '이미 완료한 캠페인입니다.',
  'viewing-022': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-022',
  'viewing-023': '해당 계정은 로그아웃된 상태입니다.',
  'viewing-024': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-024',
  'viewing-025': '계정 인증이 필요합니다.\n계정을 인중한 후에 다시 시도해주세요.',
  'viewing-026': '해당 계정이 일시적으로 차단되었습니다.\n잠시 후에 다시 시도해주세요.',
  'viewing-027':
    '서버 에러가 발생했습니다. 관리자에게 문의해 주세요. (외부 오류)\ncode: viewing-027',
  'viewing-028': '서버 에러가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-028',
  'viewing-029': '이미 완료한 캠페인입니다.',
  'viewing-030': '계정에 오류가 발생했습니다.\n계정 관리에서 계정 상태를 확인해 주세요.',
  'viewing-031': '해당 sns계정을 찾을 수 없습니다.',
  'viewing-032': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-032',
  'viewing-033':
    '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\n(외부 오류)\ncode: viewing-033',
  'viewing-034': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-034',
  'viewing-035': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-035',
  'viewing-036': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-036',
  'viewing-037': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-037',
  'viewing-038': '알 수 없는 오류가 발생했습니다.\n관리자에게 문의해 주세요.\ncode: viewing-038',
  'viewing-039':
    '해당 계정은 하루 좋아요 개수 제한을 초과했습니다. 내일 다시 시도해주 주세요. (제한: 500개)',
  'viewing-040': '보안문자 인증이 필요합니다.',
  'viewing-041': '보안문자 생성에 실패했습니다.',
  'viewing-042': '보안문자 인증에 실패했습니다.',
  'viewing-043': '인증번호가 다릅니다.',
  'viewing-044': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-044',
  'viewing-045': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-045',
  'viewing-046': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해 주세요.\ncode: viewing-046',
  'viewing-047': '계정 보호를 위해 적립을 진행할 수 없습니다. 잠시후 다시 시도해주세요.',
  'viewing-050':
    '중복 요청이 감지되어 더 이상 뷰잉하기를 진행할 수 없습니다. 잠시후 다시 시도해주세요.',
  'youtube-001': '유튜브 고유번호는 1 이상의 숫자로 입력해주세요.',
  'youtube-002': '유튜브 고유번호는 3 이하의 숫자로 입력해주세요.',
  'youtube-003': '유효한 URL을 입력해주세요.',
  'youtube-004': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: youtube-004',
  'youtube-005': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: youtube-005',
  'youtube-006': '알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요.\ncode: youtube-006',
  'youtube-007': '노출여부는 예/아니요로 입력해주세요.',
  'youtube-008': '어드민 유튜브 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
  'youtube-009': '뷰업유튜브 수정에 실패했습니다. 관리자에게 문의해주세요.',
  'youtube-010': '존재하지 않는 뷰업유튜브입니다.',
  'youtube-011': '유튜브 목록 조회에 실패했습니다. 관리자에게 문의해주세요.',
};
